import { render, staticRenderFns } from "./vPaymentMethods.vue?vue&type=template&id=083662f8&scoped=true"
import script from "./vPaymentMethods.vue?vue&type=script&lang=ts"
export * from "./vPaymentMethods.vue?vue&type=script&lang=ts"
import style0 from "./vPaymentMethods.vue?vue&type=style&index=0&id=083662f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083662f8",
  null
  
)

export default component.exports